import { Typography, makeStyles, Box, SvgIcon, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HelpIcon from '@material-ui/icons/Help';
import { useAppSelector } from '../../../store';
import { Colors } from '../../controls/helpers';

const ConfirmSave = ({ No, Yes }: { No: () => void; Yes: () => void; }) => {
    const classes = useStyles();
    const { isSubmitting } = useAppSelector(state => state.adviser);

    return <>
        <Box>
            <Box textAlign={'center'} className={classes.header}>
                <SvgIcon className={classes.icon} viewBox="0 0 600 476.6" >
                    <HelpIcon htmlColor={Colors.Green} />
                </SvgIcon>
            </Box>
            <Box className={classes.body}>
                <Typography display="block" gutterBottom>Are you sure you want to discard any unsaved changes?</Typography>
            </Box>
        </Box>
        <Box className={classes.buttonContainer}>
            <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={No} disabled={isSubmitting} key="btnCancelConfirm">No</Button>
            <Button variant="contained" color="primary" type="submit" className={classes.next} style={{ float: 'right' }} onClick={Yes} disabled={isSubmitting} key="btnConfirmConfirm">Yes</Button>
        </Box>
    </>
}

const useStyles = makeStyles({
    icon: {
        width: 200,
        height: 200
    },
    buttonContainer: {
        padding: 20
    },
    header: {
        backgroundColor: Colors.LightGrey
    },
    body: {
        background: Colors.White,
        padding: 30
    },
    next: {
        marginLeft: 'auto'
    }
}, { name: 'ConfirmSave' });

export default ConfirmSave;
